// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-tips {
    background-color: var(--primary);
    color: var(--on-primary);
    padding: 20px;
    border-radius: var(--radius-large);
    box-shadow: var(--elevation-2);
    max-width: 400px;
    width: 100vh;
    z-index: 10;
    margin: auto;
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: center;
}

.search-tips > * {
    width: 100%;
}

.search-tips h2 {
    margin-block-start: 0;
    margin-block-end: 5px;
}

.search-tips p {
    margin: 0;
    margin-block-end: 1em;
}

.search-tips ul {
    list-style: none;
    padding: 0;
    margin-block-start: 0;
    width: 80% !important;
}

.search-tips li {
    margin-block-end: 1em;
}

.search-tips code {
    padding: 2px 4px;
    font-style: italic;
}

.search-tips md-outlined-button {
    border: 1px solid var(--on-primary);
    width: 50% !important;
    max-width: 150px;
    --md-outlined-button-label-text-color: var(--on-primary);
    --md-outlined-button-hover-label-text-color: var(--primary);
    --md-outlined-button-focus-label-text-color: var(--on-primary);
    --md-outlined-button-outline-color: var(--primary);
}

.search-tips md-outlined-button:hover {
    background-color: var(--secondary-container);
}

.search-tips [data-search-tip-close-button] {
    position: absolute;
    top: 5px;
    right: 5px;
    height: 50px;
    width: 50px;
    --md-icon-button-icon-color: var(--on-primary);
    --md-icon-button-hover-icon-color: var(--on-primary);
}

@media (width < 470px) {
    .search-tips {
        max-width: 250px;
    }
}
`, "",{"version":3,"sources":["webpack://./../../assets/css/custom-tips.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,wBAAwB;IACxB,aAAa;IACb,kCAAkC;IAClC,8BAA8B;IAC9B,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;IACrB,gBAAgB;IAChB,wDAAwD;IACxD,2DAA2D;IAC3D,8DAA8D;IAC9D,kDAAkD;AACtD;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,WAAW;IACX,8CAA8C;IAC9C,oDAAoD;AACxD;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".search-tips {\n    background-color: var(--primary);\n    color: var(--on-primary);\n    padding: 20px;\n    border-radius: var(--radius-large);\n    box-shadow: var(--elevation-2);\n    max-width: 400px;\n    width: 100vh;\n    z-index: 10;\n    margin: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    align-items: center;\n}\n\n.search-tips > * {\n    width: 100%;\n}\n\n.search-tips h2 {\n    margin-block-start: 0;\n    margin-block-end: 5px;\n}\n\n.search-tips p {\n    margin: 0;\n    margin-block-end: 1em;\n}\n\n.search-tips ul {\n    list-style: none;\n    padding: 0;\n    margin-block-start: 0;\n    width: 80% !important;\n}\n\n.search-tips li {\n    margin-block-end: 1em;\n}\n\n.search-tips code {\n    padding: 2px 4px;\n    font-style: italic;\n}\n\n.search-tips md-outlined-button {\n    border: 1px solid var(--on-primary);\n    width: 50% !important;\n    max-width: 150px;\n    --md-outlined-button-label-text-color: var(--on-primary);\n    --md-outlined-button-hover-label-text-color: var(--primary);\n    --md-outlined-button-focus-label-text-color: var(--on-primary);\n    --md-outlined-button-outline-color: var(--primary);\n}\n\n.search-tips md-outlined-button:hover {\n    background-color: var(--secondary-container);\n}\n\n.search-tips [data-search-tip-close-button] {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    height: 50px;\n    width: 50px;\n    --md-icon-button-icon-color: var(--on-primary);\n    --md-icon-button-hover-icon-color: var(--on-primary);\n}\n\n@media (width < 470px) {\n    .search-tips {\n        max-width: 250px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
